// Convierte un archivo a formato base64
export const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });
};

// Crea un objeto de mensaje estandarizado
export const createMessage = (text, isUser, attachments = null, apiResponse = null) => ({
    //id: Date.now() + Math.random(), // ID único para el key de React
    text,
    isUser,
    timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    file: attachments?.file?.name || null,
    image: attachments?.image?.name || null,
    audio: attachments?.audio?.name || null,
    recordedResponse: apiResponse?.VoiceResponse || null,
    fileResponse: apiResponse?.FileResponse || null,
    imageResponse: apiResponse?.ImageResponse || null
});